import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.createUserInvitation
)

export const selectIsCreateUserInvitationModalOpen = createSelector(
    baseSelector,
    (state) => state.isCreateModalOpen
)

export const selectIsBulkUserInvitationModalOpen = createSelector(
    baseSelector,
    (state) => state.isBulkModalOpen
)

export const selectCreateUserInvitationOnCreate = createSelector(
    baseSelector,
    (state) => state.onCreate
)
